import React, { useEffect, useState } from 'react'
import { Box, IconButton, Stack, Typography } from "@mui/material"
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
// utils and helpers
import { getDistributionKitsBoxes } from "../../../../redux/slices/hyperwolf/inventoryDistribution";
// custom components
import CommonLayout from "layouts/DashboardLayout";
import ProductsListing from "./productsListing";
import { showToastMsg } from "../../distributionManagement/addRegionKit";
import AngleRightIcon from 'common/customIcons/angle_right';

export default function UpdateRefillProducts() {
  const navigate = useNavigate();
  const { action, distributionId } = useParams()
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const selectedKit = Object.fromEntries([...searchParams.entries()]);

  const [isLoading, setIsLoading] = useState(false);
  const [allBoxes, setAllBoxes] = useState([]);
  const [productsBoxes, setProductsBoxes] = useState([]);
  const [customFilters, setCustomFilters] = useState({});

  const handleGetProductsBoxes = async (filters = {}) => {
    setIsLoading(true);
    try {
      const response = await dispatch(getDistributionKitsBoxes({ ...filters, distributionId })).unwrap();
      if (response?.data) {
        setProductsBoxes(response?.data || []);
        setAllBoxes(response?.data || []);
      }
    }
    catch (error) {
      showToastMsg(error, "error")
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (selectedKit?.regionId) {
      handleGetProductsBoxes({ regionId: selectedKit?.regionId });
    }
  }, [])

  return (
    <CommonLayout>
      <Box pl={4} pt={4} className="cus-contents">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ sm: "center" }}
          justifyContent="space-between"
          gap={2}
          mb={2}
        >
          <Box display="flex" alignItems="center" color="text.main" lineHeight={1}>
            <IconButton onClick={() => navigate(-1)}>
              <AngleRightIcon fontSize="14px" />
            </IconButton>
            <Typography variant="h6" fontWeight="semibold" ml={0.75}>
              Kit Refill
              {/* ({formatTimestampToWithoutTime(Number(distributionDate))}) */}
            </Typography>
          </Box>
        </Stack>
      </Box>
      <Box p={4} pt={0} className="cus-contents">
        <ProductsListing
          checkbox={action === "delete"}
          allBoxes={allBoxes}
          productsBoxes={productsBoxes}
          setProductsBoxes={setProductsBoxes}
          selectedKit={selectedKit}
          isLoading={isLoading}
          customFilters={customFilters}
          setCustomFilters={setCustomFilters}
        />
      </Box>
    </CommonLayout>
  )
}
